// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0b5d3bc8","239":"890f3325","453":"e0769b63","732":"adafd809"}[chunkId] + ".chunk.js";
};